import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const PendingProductionOrdersRoute: RouteType = {
  name: "PendingProductionOrders",
  path: "/pending-production-orders",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Pending Production Orders",
      component: () => import("./PendingProductionOrdersHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./PendingProductionOrders"),
      grayBackground: true,
    },
  },
  dialogs: [],
  onEnter: async ({ rootStore }) => {
    try {
      // Load required data for pending production orders
      const schedulingSalesOrdersStore = rootStore[
        "scheduling-sales-ordersStore"
      ] as ServiceStore;
      const salesOrderLinesStore = rootStore[
        "sales-order-linesStore"
      ] as ServiceStore;
      const productionSchedulesStore = rootStore[
        "production-schedulesStore"
      ] as ServiceStore;
      const customersStore = rootStore.customersStore as ServiceStore;

      await Promise.all([
        schedulingSalesOrdersStore?.find(),
        salesOrderLinesStore?.find(),
        productionSchedulesStore?.find(),
        customersStore?.find(),
      ]);
    } catch (error) {
      console.error("Failed to load pending production orders data:", error);
    }
  },
};

export default PendingProductionOrdersRoute;
